import Vue from "vue";
import App from "./App.vue";
import VueMoment from "vue-moment";
import router from "./router";
import store from "./store";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import mixins from "@/plugins/mixins";
import "@/plugins/validation";
import VueDragscroll from 'vue-dragscroll';
Vue.use(VueDragscroll)

window.apiUrl = process.env.VUE_APP_BASE_API_URL;
Vue.config.productionTip = false;
Vue.use(VueMoment);
Vue.mixin(mixins);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
